// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard_inner:has(.quickstart-section) {
  gap: 0.5rem;
}

/* Quickstart Section */
.quickstart-section {
  margin-bottom: 0;
}

.quickstart-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 0;
  cursor: pointer;
  color: #4c5fd5;
  font-size: 14px;
}

.quickstart-section:has(.segment-cards) .quickstart-header {
  margin-bottom: 8px;
}

.chevron {
  font-size: 12px;
}

.segment-cards {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  margin-bottom: 0;
}

.segment-card {
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 12px 14px;
  transition: all 0.2s;
}

.segment-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
}

.card-header h3 {
  font-size: 16px;
  font-weight: 600;
  margin: 0;
  color: #1a1a1a;
}

.card-icon {
  font-size: 24px;
}

.card-description {
  font-size: 13px;
  color: #666;
  line-height: 1.4;
  margin-bottom: 10px;
  min-height: 0;
}

.btn-create {
  background: transparent;
  border: 1px solid #4c5fd5;
  color: #4c5fd5;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;
  transition: all 0.2s;
}

.btn-create:hover {
  background-color: #4c5fd5;
  color: white;
}

/* Tabs */
.tabs {
  display: flex;
  gap: 0;
  border-bottom: 2px solid #e0e0e0;
  margin-bottom: 12px;
}

.tab {
  background: transparent;
  border: none;
  padding: 12px 20px;
  cursor: pointer;
  font-size: 14px;
  color: #666;
  border-bottom: 3px solid transparent;
  margin-bottom: -2px;
  transition: all 0.2s;
}

.tab:hover {
  color: #1a1a1a;
}

.tab.active {
  color: #4c5fd5;
  border-bottom-color: #4c5fd5;
  font-weight: 500;
}

.tab-count {
  margin-left: 6px;
  color: inherit;
}

/* Search Section */
.search-section {
  display: flex;
  gap: 12px;
  margin-bottom: 20px;
}

.search-bar {
  flex: 1 1;
  display: flex;
  align-items: center;
  background: white;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 10px 16px;
  gap: 10px;
}

.search-icon {
  color: #999;
}

.search-bar input {
  flex: 1 1;
  border: none;
  outline: none;
  font-size: 14px;
}

.filter-btn {
  background: white;
  border: 1px solid #ddd;
  padding: 10px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 18px;
  transition: all 0.2s;
}

.filter-btn:hover {
  background-color: #f8f8f8;
}

/* Table */
.segments-table {
  background: white;
  border-radius: 8px;
  overflow: visible;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.segments-table table {
  width: 100%;
  min-width: 800px;
  border-collapse: collapse;
}

.segments-table thead {
  background-color: #fafafa;
}

.segments-table th {
  text-align: left;
  padding: 16px;
  font-size: 13px;
  font-weight: 600;
  color: #666;
  border-bottom: 1px solid #e0e0e0;
}

.segments-table td {
  padding: 16px;
  font-size: 14px;
  border-bottom: 1px solid #f0f0f0;
}

.segments-table tbody tr {
  position: relative;
}

.segments-table tbody tr:hover {
  background-color: #fafafa;
}

.segment-name {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.segment-name strong {
  font-weight: 600;
  color: #1a1a1a;
}

.tag {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #666;
}

.tag-icon {
  font-size: 14px;
}

.type-icon {
  font-size: 18px;
}

.status-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
}

.status-badge.active {
  background-color: #e6f4ea;
  color: #1e8e3e;
}

.status-badge.paused {
  background-color: #fef3e0;
  color: #f57c00;
}

.menu-btn {
  background: transparent;
  border: none;
  cursor: pointer;
  font-size: 20px;
  color: #666;
  padding: 4px 8px;
  transition: all 0.2s;
}

.menu-btn:hover {
  background-color: #f0f0f0;
  border-radius: 4px;
}

/* Bootstrap Modal Customization */
.segment-editor-modal .modal-dialog {
  max-width: 90%;
  width: 1000px;
}

.segment-editor-modal .modal-header {
  padding: 20px 30px;
  border-bottom: 1px solid #dee2e6;
  background-color: #fff;
}

.segment-editor-modal .modal-title {
  font-size: 22px;
  font-weight: 600;
  color: #212529;
}

.segment-editor-modal .modal-body {
  padding: 0;
  max-height: calc(85vh - 140px);
  overflow: hidden;
}

.segment-editor-modal .modal-footer {
  padding: 20px 30px;
  border-top: 1px solid #dee2e6;
  justify-content: flex-end;
  background-color: #fff;
}

.modal-body-content {
  display: flex;
  flex-direction: column;
  min-height: 500px;
  max-height: calc(85vh - 140px);
}

.modal-full-width {
  flex: 1 1;
  padding: 30px;
  overflow-y: auto;
  background-color: #fff;
}

.form-row-with-status {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 30px;
  margin-bottom: 28px;
}

.form-group-inline {
  flex: 1 1;
  max-width: 500px;
}

.form-group {
  margin-bottom: 28px;
}

.form-group label,
.form-group-inline label {
  display: block;
  font-size: 13px;
  font-weight: 400;
  color: #020304;
  margin-bottom: 10px;
}

.required {
  color: #dc3545;
  margin-left: 2px;
}

.segment-name-input {
  width: 100%;
  padding: 10px 14px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 14px;
  outline: none;
  transition: all 0.2s;
  background-color: #f8f9fa;
}

.segment-name-input:focus {
  border-color: #6366f1;
  box-shadow: 0 0 0 0.2rem rgba(99, 102, 241, 0.15);
  background-color: #fff;
}

.rules-section {
  margin-top: 20px;
}

.rules-title {
  font-size: 14px;
  /* color: #495057; */
  margin-bottom: 18px;
  font-weight: 500;
}

.rules-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 50px;
}

.rule-item {
  display: flex;
  align-items: stretch;
  gap: 0;
  border-radius: 6px;
  overflow: hidden;
  transition: all 0.2s;
}

.rule-left {
  background-color: #dde1e6;
  padding: 14px 16px;
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 180px;
  flex-shrink: 0;
}

.rule-right {
  background-color: #ffffff;
  padding: 12px 20px;
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1 1;
}

.rule-item:hover .rule-right {
  background-color: #dde1e6;
}

.rule-icon {
  font-size: 18px;
  width: 20px;
  text-align: center;
  flex-shrink: 0;
  color: #6c757d;
}

.rule-title {
  font-size: 15px;
  font-weight: 500;
  color: #333333;
  white-space: nowrap;
}

.rule-description {
  font-size: 15px;
  color: #666666;
  line-height: 1.4;
  flex: 1 1;
}

.rule-add-btn {
  background-color: transparent;
  color: #6366f1;
  border: none;
  width: 28px;
  height: 28px;
  border-radius: 4px;
  font-size: 24px;
  font-weight: 300;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  flex-shrink: 0;
  line-height: 1;
}

.rule-add-btn:hover {
  background-color: #6366f1;
  color: white;
}

.subscribed-records {
  text-align: right;
  flex-shrink: 0;
}

.records-label {
  font-size: 16px;
  color: #adb5bd;
  margin-bottom: 8px;
  font-weight: 400;
  display: block;
}

.records-status {
  font-size: 26px;
  font-weight: 600;
  color: #212529;
  line-height: 1.1;
  display: block;
}

.btn-create-segment {
  background-color: #6366f1;
  color: white;
  border: none;
  padding: 10px 28px;
  border-radius: 5px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-create-segment:hover {
  background-color: #4f46e5;
}

.btn-create-segment:disabled {
  background-color: #adb5bd;
  cursor: not-allowed;
}

/* Responsive */
@media (max-width: 1400px) {
  .segment-cards {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 1200px) {
  .segment-cards {
    grid-template-columns: repeat(2, 1fr);
  }

  .segments-table table {
    min-width: 900px;
  }
}

@media (max-width: 768px) {
  .segment-cards {
    grid-template-columns: 1fr;
  }

  .search-section {
    flex-direction: column;
  }

  .filter-btn {
    width: 100%;
  }

  .segment-editor-modal .modal-dialog {
    max-width: 100%;
    margin: 0;
  }

  .modal-body-content {
    min-height: auto;
  }

  .modal-full-width {
    padding: 20px;
  }

  .form-row-with-status {
    flex-direction: column;
    gap: 20px;
  }

  .form-group-inline {
    max-width: 100%;
  }

  .subscribed-records {
    text-align: left;
  }

  .rule-item {
    flex-direction: column;
  }

  .rule-left {
    min-width: 100%;
  }

  .rule-right {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .rule-add-btn {
    align-self: flex-end;
  }
}

/* Added Filter Styles */
.added-filter-container {
  margin-bottom: 20px;
}

.or-filter-label {
  background-color: #f8f9fa;
  color: #6c757d;
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 500;
  border-radius: 4px;
  margin-bottom: 10px;
  display: inline-block;
}

.added-filter {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  padding: 16px;
  margin-bottom: 12px;
}

.filter-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
}

.filter-title-section {
  display: flex;
  align-items: center;
  gap: 10px;
}

.filter-icon {
  font-size: 18px;
}

.filter-name {
  font-size: 15px;
  font-weight: 500;
  color: #333;
}

.filter-remove-btn {
  background: transparent;
  border: none;
  color: #6c757d;
  font-size: 24px;
  cursor: pointer;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s;
  line-height: 1;
}

.filter-remove-btn:hover {
  background-color: #dc3545;
  color: white;
}

.filter-config {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.filter-row {
  display: flex;
  gap: 12px;
  align-items: center;
}

.filter-input,
.filter-select {
  padding: 8px 12px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 14px;
  outline: none;
  transition: all 0.2s;
  background-color: white;
}

.filter-input:focus,
.filter-select:focus {
  border-color: #6366f1;
  box-shadow: 0 0 0 0.2rem rgba(99, 102, 241, 0.15);
}

.filter-key {
  flex: 1 1;
  max-width: 300px;
}

.filter-select {
  min-width: 200px;
}

.filter-value {
  flex: 1 1;
  max-width: 300px;
}

.filter-time-unit {
  min-width: 140px;
}

.filter-help-text {
  font-size: 12px;
  color: #6c757d;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  background-color: #e7f3ff;
  border-radius: 4px;
  border: 1px solid #b3d9ff;
}

.filter-count-text {
  font-size: 13px;
  color: #333;
  padding: 8px 12px;
  margin-top: 8px;
  text-align: right;
  font-weight: 500;
}

.filter-actions {
  display: flex;
  gap: 12px;
  margin-bottom: 24px;
}

.btn-add-filter,
.btn-add-or {
  background-color: transparent;
  color: #6366f1;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.2s;
}

.btn-add-filter:hover,
.btn-add-or:hover {
  background-color: #e7e9fc;
}

.add-icon {
  font-size: 16px;
  font-weight: 300;
}

/* Responsive for added filters */
@media (max-width: 768px) {
  .filter-row {
    flex-direction: column;
    align-items: stretch;
  }

  .filter-key,
  .filter-select,
  .filter-value {
    max-width: 100%;
    width: 100%;
  }

  .filter-actions {
    flex-direction: column;
  }

  .btn-add-filter,
  .btn-add-or {
    width: 100%;
    justify-content: center;
  }
}

/* And Filter Selector Styles */
.and-filter-selector {
  background-color: #ffffff;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  margin-bottom: 24px;
  overflow: hidden;
}

.and-filter-header {
  background-color: #f8f9fa;
  padding: 12px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #dee2e6;
}

.and-filter-label {
  font-size: 14px;
  font-weight: 500;
  color: #333;
}

.and-filter-close {
  background: transparent;
  border: none;
  color: #6c757d;
  font-size: 24px;
  cursor: pointer;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s;
  line-height: 1;
}

.and-filter-close:hover {
  background-color: #dc3545;
  color: white;
}

.and-filter-rules-list {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.and-filter-rule-item {
  display: flex;
  align-items: stretch;
  gap: 0;
  border-bottom: 1px solid #f0f0f0;
  transition: all 0.2s;
}

.and-filter-rule-item:last-child {
  border-bottom: none;
}

.and-filter-rule-left {
  background-color: #f8f9fa;
  padding: 14px 16px;
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 180px;
  flex-shrink: 0;
}

.and-filter-rule-right {
  background-color: #ffffff;
  padding: 12px 20px;
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1 1;
}

.and-filter-rule-item:hover .and-filter-rule-right {
  background-color: #f8f9fa;
}

.and-filter-rule-icon {
  font-size: 18px;
  width: 20px;
  text-align: center;
  flex-shrink: 0;
  color: #6c757d;
}

.and-filter-rule-title {
  font-size: 15px;
  font-weight: 500;
  color: #333333;
  white-space: nowrap;
}

.and-filter-rule-description {
  font-size: 15px;
  color: #666666;
  line-height: 1.4;
  flex: 1 1;
}

.and-filter-rule-add-btn {
  background-color: transparent;
  color: #6366f1;
  border: none;
  width: 28px;
  height: 28px;
  border-radius: 4px;
  font-size: 24px;
  font-weight: 300;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  flex-shrink: 0;
  line-height: 1;
}

.and-filter-rule-add-btn:hover {
  background-color: #6366f1;
  color: white;
}

/* Responsive for And Filter Selector */
@media (max-width: 768px) {
  .and-filter-rule-item {
    flex-direction: column;
  }

  .and-filter-rule-left {
    min-width: 100%;
  }

  .and-filter-rule-right {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .and-filter-rule-add-btn {
    align-self: flex-end;
  }
}

/* Action Menu Styles */
.segment-action-menu {
  /* Dropdown now uses shared \`.dropdown-menu-subscription\` design */
  overflow: visible;
}

/* Legacy menu styles removed (menu-item/menu-icon) */


/* Message Event Filter Styles */
.filter-count-value {
  width: 80px;
  text-align: center;
}

.filter-label-text {
  font-size: 14px;
  color: #333;
  padding: 0 4px;
  white-space: nowrap;
}

.message-event-info {
  background-color: #e7f3ff;
  border: 1px solid #b3d9ff;
  border-radius: 6px;
  padding: 12px 16px;
  margin-bottom: 20px;
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.message-event-info-icon {
  color: #4c5fd5;
  font-size: 18px;
  flex-shrink: 0;
}

.message-event-info-text {
  font-size: 13px;
  color: #333;
  line-height: 1.5;
}

.message-event-info-text a {
  color: #4c5fd5;
  text-decoration: underline;
}


/* State Filter Styles */
.filter-state-select {
  min-width: 200px;
}

/* AND label between filters */
.and-label {
  background-color: #f0f0f0;
  color: #666;
  padding: 4px 12px;
  font-size: 12px;
  font-weight: 600;
  border-radius: 4px;
  margin: 8px 0;
  display: inline-block;
}`, "",{"version":3,"sources":["webpack://./src/components/users/Segments.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA,SAAS;AACT;EACE,aAAa;EACb,MAAM;EACN,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,WAAW;EACX,oCAAoC;EACpC,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,UAAU;AACV;EACE,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,kCAAkC;AAClC;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,iDAAiD;EACjD,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,MAAM;EACN,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;AACT;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA,wBAAwB;AACxB;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;;EAEE,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,6BAA6B;EAC7B,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,iCAAiC;AACjC;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;;;IAGE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;IACX,uBAAuB;EACzB;AACF;;AAEA,+BAA+B;AAC/B;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,MAAM;EACN,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;AACT;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA,uCAAuC;AACvC;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA,uBAAuB;AACvB;EACE,kEAAkE;EAClE,iBAAiB;AACnB;;AAEA,qDAAqD;;;AAGrD,gCAAgC;AAChC;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;;AAGA,wBAAwB;AACxB;EACE,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,qBAAqB;AACvB","sourcesContent":[".dashboard_inner:has(.quickstart-section) {\n  gap: 0.5rem;\n}\n\n/* Quickstart Section */\n.quickstart-section {\n  margin-bottom: 0;\n}\n\n.quickstart-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 0;\n  cursor: pointer;\n  color: #4c5fd5;\n  font-size: 14px;\n}\n\n.quickstart-section:has(.segment-cards) .quickstart-header {\n  margin-bottom: 8px;\n}\n\n.chevron {\n  font-size: 12px;\n}\n\n.segment-cards {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 12px;\n  margin-bottom: 0;\n}\n\n.segment-card {\n  background: white;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  padding: 12px 14px;\n  transition: all 0.2s;\n}\n\n.segment-card:hover {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 12px;\n}\n\n.card-header h3 {\n  font-size: 16px;\n  font-weight: 600;\n  margin: 0;\n  color: #1a1a1a;\n}\n\n.card-icon {\n  font-size: 24px;\n}\n\n.card-description {\n  font-size: 13px;\n  color: #666;\n  line-height: 1.4;\n  margin-bottom: 10px;\n  min-height: 0;\n}\n\n.btn-create {\n  background: transparent;\n  border: 1px solid #4c5fd5;\n  color: #4c5fd5;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 13px;\n  transition: all 0.2s;\n}\n\n.btn-create:hover {\n  background-color: #4c5fd5;\n  color: white;\n}\n\n/* Tabs */\n.tabs {\n  display: flex;\n  gap: 0;\n  border-bottom: 2px solid #e0e0e0;\n  margin-bottom: 12px;\n}\n\n.tab {\n  background: transparent;\n  border: none;\n  padding: 12px 20px;\n  cursor: pointer;\n  font-size: 14px;\n  color: #666;\n  border-bottom: 3px solid transparent;\n  margin-bottom: -2px;\n  transition: all 0.2s;\n}\n\n.tab:hover {\n  color: #1a1a1a;\n}\n\n.tab.active {\n  color: #4c5fd5;\n  border-bottom-color: #4c5fd5;\n  font-weight: 500;\n}\n\n.tab-count {\n  margin-left: 6px;\n  color: inherit;\n}\n\n/* Search Section */\n.search-section {\n  display: flex;\n  gap: 12px;\n  margin-bottom: 20px;\n}\n\n.search-bar {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  background: white;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  padding: 10px 16px;\n  gap: 10px;\n}\n\n.search-icon {\n  color: #999;\n}\n\n.search-bar input {\n  flex: 1;\n  border: none;\n  outline: none;\n  font-size: 14px;\n}\n\n.filter-btn {\n  background: white;\n  border: 1px solid #ddd;\n  padding: 10px 16px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 18px;\n  transition: all 0.2s;\n}\n\n.filter-btn:hover {\n  background-color: #f8f8f8;\n}\n\n/* Table */\n.segments-table {\n  background: white;\n  border-radius: 8px;\n  overflow: visible;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.segments-table table {\n  width: 100%;\n  min-width: 800px;\n  border-collapse: collapse;\n}\n\n.segments-table thead {\n  background-color: #fafafa;\n}\n\n.segments-table th {\n  text-align: left;\n  padding: 16px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #666;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.segments-table td {\n  padding: 16px;\n  font-size: 14px;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.segments-table tbody tr {\n  position: relative;\n}\n\n.segments-table tbody tr:hover {\n  background-color: #fafafa;\n}\n\n.segment-name {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.segment-name strong {\n  font-weight: 600;\n  color: #1a1a1a;\n}\n\n.tag {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  color: #666;\n}\n\n.tag-icon {\n  font-size: 14px;\n}\n\n.type-icon {\n  font-size: 18px;\n}\n\n.status-badge {\n  display: inline-block;\n  padding: 4px 12px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.status-badge.active {\n  background-color: #e6f4ea;\n  color: #1e8e3e;\n}\n\n.status-badge.paused {\n  background-color: #fef3e0;\n  color: #f57c00;\n}\n\n.menu-btn {\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  font-size: 20px;\n  color: #666;\n  padding: 4px 8px;\n  transition: all 0.2s;\n}\n\n.menu-btn:hover {\n  background-color: #f0f0f0;\n  border-radius: 4px;\n}\n\n/* Bootstrap Modal Customization */\n.segment-editor-modal .modal-dialog {\n  max-width: 90%;\n  width: 1000px;\n}\n\n.segment-editor-modal .modal-header {\n  padding: 20px 30px;\n  border-bottom: 1px solid #dee2e6;\n  background-color: #fff;\n}\n\n.segment-editor-modal .modal-title {\n  font-size: 22px;\n  font-weight: 600;\n  color: #212529;\n}\n\n.segment-editor-modal .modal-body {\n  padding: 0;\n  max-height: calc(85vh - 140px);\n  overflow: hidden;\n}\n\n.segment-editor-modal .modal-footer {\n  padding: 20px 30px;\n  border-top: 1px solid #dee2e6;\n  justify-content: flex-end;\n  background-color: #fff;\n}\n\n.modal-body-content {\n  display: flex;\n  flex-direction: column;\n  min-height: 500px;\n  max-height: calc(85vh - 140px);\n}\n\n.modal-full-width {\n  flex: 1;\n  padding: 30px;\n  overflow-y: auto;\n  background-color: #fff;\n}\n\n.form-row-with-status {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 30px;\n  margin-bottom: 28px;\n}\n\n.form-group-inline {\n  flex: 1;\n  max-width: 500px;\n}\n\n.form-group {\n  margin-bottom: 28px;\n}\n\n.form-group label,\n.form-group-inline label {\n  display: block;\n  font-size: 13px;\n  font-weight: 400;\n  color: #020304;\n  margin-bottom: 10px;\n}\n\n.required {\n  color: #dc3545;\n  margin-left: 2px;\n}\n\n.segment-name-input {\n  width: 100%;\n  padding: 10px 14px;\n  border: 1px solid #ced4da;\n  border-radius: 4px;\n  font-size: 14px;\n  outline: none;\n  transition: all 0.2s;\n  background-color: #f8f9fa;\n}\n\n.segment-name-input:focus {\n  border-color: #6366f1;\n  box-shadow: 0 0 0 0.2rem rgba(99, 102, 241, 0.15);\n  background-color: #fff;\n}\n\n.rules-section {\n  margin-top: 20px;\n}\n\n.rules-title {\n  font-size: 14px;\n  /* color: #495057; */\n  margin-bottom: 18px;\n  font-weight: 500;\n}\n\n.rules-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-bottom: 50px;\n}\n\n.rule-item {\n  display: flex;\n  align-items: stretch;\n  gap: 0;\n  border-radius: 6px;\n  overflow: hidden;\n  transition: all 0.2s;\n}\n\n.rule-left {\n  background-color: #dde1e6;\n  padding: 14px 16px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 180px;\n  flex-shrink: 0;\n}\n\n.rule-right {\n  background-color: #ffffff;\n  padding: 12px 20px;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  flex: 1;\n}\n\n.rule-item:hover .rule-right {\n  background-color: #dde1e6;\n}\n\n.rule-icon {\n  font-size: 18px;\n  width: 20px;\n  text-align: center;\n  flex-shrink: 0;\n  color: #6c757d;\n}\n\n.rule-title {\n  font-size: 15px;\n  font-weight: 500;\n  color: #333333;\n  white-space: nowrap;\n}\n\n.rule-description {\n  font-size: 15px;\n  color: #666666;\n  line-height: 1.4;\n  flex: 1;\n}\n\n.rule-add-btn {\n  background-color: transparent;\n  color: #6366f1;\n  border: none;\n  width: 28px;\n  height: 28px;\n  border-radius: 4px;\n  font-size: 24px;\n  font-weight: 300;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s;\n  flex-shrink: 0;\n  line-height: 1;\n}\n\n.rule-add-btn:hover {\n  background-color: #6366f1;\n  color: white;\n}\n\n.subscribed-records {\n  text-align: right;\n  flex-shrink: 0;\n}\n\n.records-label {\n  font-size: 16px;\n  color: #adb5bd;\n  margin-bottom: 8px;\n  font-weight: 400;\n  display: block;\n}\n\n.records-status {\n  font-size: 26px;\n  font-weight: 600;\n  color: #212529;\n  line-height: 1.1;\n  display: block;\n}\n\n.btn-create-segment {\n  background-color: #6366f1;\n  color: white;\n  border: none;\n  padding: 10px 28px;\n  border-radius: 5px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.btn-create-segment:hover {\n  background-color: #4f46e5;\n}\n\n.btn-create-segment:disabled {\n  background-color: #adb5bd;\n  cursor: not-allowed;\n}\n\n/* Responsive */\n@media (max-width: 1400px) {\n  .segment-cards {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n@media (max-width: 1200px) {\n  .segment-cards {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .segments-table table {\n    min-width: 900px;\n  }\n}\n\n@media (max-width: 768px) {\n  .segment-cards {\n    grid-template-columns: 1fr;\n  }\n\n  .search-section {\n    flex-direction: column;\n  }\n\n  .filter-btn {\n    width: 100%;\n  }\n\n  .segment-editor-modal .modal-dialog {\n    max-width: 100%;\n    margin: 0;\n  }\n\n  .modal-body-content {\n    min-height: auto;\n  }\n\n  .modal-full-width {\n    padding: 20px;\n  }\n\n  .form-row-with-status {\n    flex-direction: column;\n    gap: 20px;\n  }\n\n  .form-group-inline {\n    max-width: 100%;\n  }\n\n  .subscribed-records {\n    text-align: left;\n  }\n\n  .rule-item {\n    flex-direction: column;\n  }\n\n  .rule-left {\n    min-width: 100%;\n  }\n\n  .rule-right {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 10px;\n  }\n\n  .rule-add-btn {\n    align-self: flex-end;\n  }\n}\n\n/* Added Filter Styles */\n.added-filter-container {\n  margin-bottom: 20px;\n}\n\n.or-filter-label {\n  background-color: #f8f9fa;\n  color: #6c757d;\n  padding: 8px 16px;\n  font-size: 13px;\n  font-weight: 500;\n  border-radius: 4px;\n  margin-bottom: 10px;\n  display: inline-block;\n}\n\n.added-filter {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n  border-radius: 6px;\n  padding: 16px;\n  margin-bottom: 12px;\n}\n\n.filter-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 14px;\n}\n\n.filter-title-section {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.filter-icon {\n  font-size: 18px;\n}\n\n.filter-name {\n  font-size: 15px;\n  font-weight: 500;\n  color: #333;\n}\n\n.filter-remove-btn {\n  background: transparent;\n  border: none;\n  color: #6c757d;\n  font-size: 24px;\n  cursor: pointer;\n  width: 28px;\n  height: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  transition: all 0.2s;\n  line-height: 1;\n}\n\n.filter-remove-btn:hover {\n  background-color: #dc3545;\n  color: white;\n}\n\n.filter-config {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.filter-row {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n.filter-input,\n.filter-select {\n  padding: 8px 12px;\n  border: 1px solid #ced4da;\n  border-radius: 4px;\n  font-size: 14px;\n  outline: none;\n  transition: all 0.2s;\n  background-color: white;\n}\n\n.filter-input:focus,\n.filter-select:focus {\n  border-color: #6366f1;\n  box-shadow: 0 0 0 0.2rem rgba(99, 102, 241, 0.15);\n}\n\n.filter-key {\n  flex: 1;\n  max-width: 300px;\n}\n\n.filter-select {\n  min-width: 200px;\n}\n\n.filter-value {\n  flex: 1;\n  max-width: 300px;\n}\n\n.filter-time-unit {\n  min-width: 140px;\n}\n\n.filter-help-text {\n  font-size: 12px;\n  color: #6c757d;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 12px;\n  background-color: #e7f3ff;\n  border-radius: 4px;\n  border: 1px solid #b3d9ff;\n}\n\n.filter-count-text {\n  font-size: 13px;\n  color: #333;\n  padding: 8px 12px;\n  margin-top: 8px;\n  text-align: right;\n  font-weight: 500;\n}\n\n.filter-actions {\n  display: flex;\n  gap: 12px;\n  margin-bottom: 24px;\n}\n\n.btn-add-filter,\n.btn-add-or {\n  background-color: transparent;\n  color: #6366f1;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  font-size: 14px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  transition: all 0.2s;\n}\n\n.btn-add-filter:hover,\n.btn-add-or:hover {\n  background-color: #e7e9fc;\n}\n\n.add-icon {\n  font-size: 16px;\n  font-weight: 300;\n}\n\n/* Responsive for added filters */\n@media (max-width: 768px) {\n  .filter-row {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .filter-key,\n  .filter-select,\n  .filter-value {\n    max-width: 100%;\n    width: 100%;\n  }\n\n  .filter-actions {\n    flex-direction: column;\n  }\n\n  .btn-add-filter,\n  .btn-add-or {\n    width: 100%;\n    justify-content: center;\n  }\n}\n\n/* And Filter Selector Styles */\n.and-filter-selector {\n  background-color: #ffffff;\n  border: 1px solid #dee2e6;\n  border-radius: 6px;\n  margin-bottom: 24px;\n  overflow: hidden;\n}\n\n.and-filter-header {\n  background-color: #f8f9fa;\n  padding: 12px 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid #dee2e6;\n}\n\n.and-filter-label {\n  font-size: 14px;\n  font-weight: 500;\n  color: #333;\n}\n\n.and-filter-close {\n  background: transparent;\n  border: none;\n  color: #6c757d;\n  font-size: 24px;\n  cursor: pointer;\n  width: 28px;\n  height: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  transition: all 0.2s;\n  line-height: 1;\n}\n\n.and-filter-close:hover {\n  background-color: #dc3545;\n  color: white;\n}\n\n.and-filter-rules-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.and-filter-rule-item {\n  display: flex;\n  align-items: stretch;\n  gap: 0;\n  border-bottom: 1px solid #f0f0f0;\n  transition: all 0.2s;\n}\n\n.and-filter-rule-item:last-child {\n  border-bottom: none;\n}\n\n.and-filter-rule-left {\n  background-color: #f8f9fa;\n  padding: 14px 16px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 180px;\n  flex-shrink: 0;\n}\n\n.and-filter-rule-right {\n  background-color: #ffffff;\n  padding: 12px 20px;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  flex: 1;\n}\n\n.and-filter-rule-item:hover .and-filter-rule-right {\n  background-color: #f8f9fa;\n}\n\n.and-filter-rule-icon {\n  font-size: 18px;\n  width: 20px;\n  text-align: center;\n  flex-shrink: 0;\n  color: #6c757d;\n}\n\n.and-filter-rule-title {\n  font-size: 15px;\n  font-weight: 500;\n  color: #333333;\n  white-space: nowrap;\n}\n\n.and-filter-rule-description {\n  font-size: 15px;\n  color: #666666;\n  line-height: 1.4;\n  flex: 1;\n}\n\n.and-filter-rule-add-btn {\n  background-color: transparent;\n  color: #6366f1;\n  border: none;\n  width: 28px;\n  height: 28px;\n  border-radius: 4px;\n  font-size: 24px;\n  font-weight: 300;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s;\n  flex-shrink: 0;\n  line-height: 1;\n}\n\n.and-filter-rule-add-btn:hover {\n  background-color: #6366f1;\n  color: white;\n}\n\n/* Responsive for And Filter Selector */\n@media (max-width: 768px) {\n  .and-filter-rule-item {\n    flex-direction: column;\n  }\n\n  .and-filter-rule-left {\n    min-width: 100%;\n  }\n\n  .and-filter-rule-right {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 10px;\n  }\n\n  .and-filter-rule-add-btn {\n    align-self: flex-end;\n  }\n}\n\n/* Action Menu Styles */\n.segment-action-menu {\n  /* Dropdown now uses shared `.dropdown-menu-subscription` design */\n  overflow: visible;\n}\n\n/* Legacy menu styles removed (menu-item/menu-icon) */\n\n\n/* Message Event Filter Styles */\n.filter-count-value {\n  width: 80px;\n  text-align: center;\n}\n\n.filter-label-text {\n  font-size: 14px;\n  color: #333;\n  padding: 0 4px;\n  white-space: nowrap;\n}\n\n.message-event-info {\n  background-color: #e7f3ff;\n  border: 1px solid #b3d9ff;\n  border-radius: 6px;\n  padding: 12px 16px;\n  margin-bottom: 20px;\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n}\n\n.message-event-info-icon {\n  color: #4c5fd5;\n  font-size: 18px;\n  flex-shrink: 0;\n}\n\n.message-event-info-text {\n  font-size: 13px;\n  color: #333;\n  line-height: 1.5;\n}\n\n.message-event-info-text a {\n  color: #4c5fd5;\n  text-decoration: underline;\n}\n\n\n/* State Filter Styles */\n.filter-state-select {\n  min-width: 200px;\n}\n\n/* AND label between filters */\n.and-label {\n  background-color: #f0f0f0;\n  color: #666;\n  padding: 4px 12px;\n  font-size: 12px;\n  font-weight: 600;\n  border-radius: 4px;\n  margin: 8px 0;\n  display: inline-block;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
